import { t } from 'i18next';
import { useRevealOnScroll } from 'src/shared';

export default function LpFaq() {
  const headRef = useRevealOnScroll<HTMLDivElement>();
  const faqRef = useRevealOnScroll<HTMLDivElement>();

  const items = [
    { questionKey: 'landingPage.v2.faq.q1.question', answerKey: 'landingPage.v2.faq.q1.answer' },
    { questionKey: 'landingPage.v2.faq.q2.question', answerKey: 'landingPage.v2.faq.q2.answer' },
    { questionKey: 'landingPage.v2.faq.q3.question', answerKey: 'landingPage.v2.faq.q3.answer' },
  ];

  return (
    <section className="section-pad" aria-labelledby="lp-faq-title">
      <div className="wrap">
        <div ref={headRef} className="sec-head reveal" style={{ textAlign: 'center' }}>
          <span className="eyebrow" style={{ justifyContent: 'center' }}>
            <span className="dot" />{t('landingPage.v2.faq.label')}
          </span>
          <h2 className="display" id="lp-faq-title">{t('landingPage.v2.faq.title')}</h2>
        </div>
        <div ref={faqRef} className="faq reveal">
          {items.map((item, i) => (
            <details key={i} open={i === 0 || undefined}>
              <summary>
                {t(item.questionKey)}
                <span className="ic" />
              </summary>
              <p>{t(item.answerKey)}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
